import JitsiMeetJS from "./_";
import $ from "jquery";
import { jitsiLocalStorage } from "@jitsi/js-utils";
import { conference } from "../App";
import {
  trackAdd,
  trackRemove,
  setDominantSpeaker,
  trackMediaTypeUpdate,
  trackMuteUpdate,
  setMediaShareParticipants,
  remMediaShareParticipants,
  setRecentActiveSpeaker,
  setAttendeesFrameRate,
} from "../reduxStore/confSlice";
import { config as defaultConfig } from "./config";
import { store } from "../reduxStore/store";
import { getIP, getPartcipiantsUserIds, handleTrackStreamingStatusChanged, logSentryCustomEvent } from "../utils/functions";
import { COUNTRY_CODES, P_NAME_REQUESTING_TRANSCRIPTION, P_NAME_TRANSCRIPTION_LANGUAGE, P_NAME_TRANSLATION_LANGUAGE, TRANSCRIBER_DIAL_NUMBER } from "../utils/util";
import { sendCaptionMsg, updateDominantData } from "../utils/socket";
export { JitsiMeetJS as default };
export const browser = JitsiMeetJS.util.browser;
export const JitsiConferenceErrors = JitsiMeetJS.errors.conference;
export const JitsiConferenceEvents = JitsiMeetJS.events.conference;
export const JitsiConnectionErrors = JitsiMeetJS.errors.connection;
export const JitsiConnectionEvents = JitsiMeetJS.events.connection;
export const JitsiConnectionQualityEvents =
  JitsiMeetJS.events.connectionQuality;
export const JitsiDetectionEvents = JitsiMeetJS.events.detection;
export const JitsiE2ePingEvents = JitsiMeetJS.events.e2eping;
export const JitsiMediaDevicesEvents = JitsiMeetJS.events.mediaDevices;
export const JitsiParticipantConnectionStatus =
  JitsiMeetJS.constants.participantConnectionStatus;
export const JitsiTrackStreamingStatus =
  JitsiMeetJS.constants.trackStreamingStatus;
export const JitsiRecordingConstants = JitsiMeetJS.constants.recording;
export const JitsiSIPVideoGWStatus = JitsiMeetJS.constants.sipVideoGW;
export const JitsiTrackErrors = JitsiMeetJS.errors.track;
export const JitsiTrackEvents = JitsiMeetJS.events.track;
export const JitsiMediaDevices = JitsiMeetJS.mediaDevices;
export const createLocalTracks = JitsiMeetJS.createLocalTracks;
let dispatch = null;
let jitsiConnection = null;
let room = null;
let bridgeLogged = false;
let captionListnerEnabled = false;
let transcriptionEnabled = false;
let lemUserLanguages = {};

let config = { ...defaultConfig };
const LAST_30_SECONDS = 30000;
const captionBuffer = [];

window.globalUnload = () => {
  room?.leave();
  jitsiConnection?.disconnect();
};

function unload() {
  setTimeout(() => {
    room?.leave();
    jitsiConnection?.disconnect();
  }, 1000);
}

$(window).bind("beforeunload", unload);
$(window).bind("unload", unload);

export function GetRoom() {
  return room;
}
export const MEDIA_TYPE = {
  AUDIO: "audio",
  PRESENTER: "presenter",
  SCREENSHARE: "screenshare",
  VIDEO: "video",
};
export function init(d, roomName, domain) {
  JitsiMeetJS.setLogLevel(JitsiMeetJS.logLevels.ERROR);
  dispatch = d;

  config.hosts.muc = 'conference.' + domain;
  config.hosts.focus = 'focus.' + domain;
  config.hosts.domain = domain;
  config.bosh = 'https://' + domain + '/http-bind';
  config.serviceUrl = 'wss://' + domain + '/xmpp-websocket' + `?room=${roomName}`;
  config.websocketKeepAliveUrl = 'https://' + domain + `?room=${roomName}`;
  config.clientNode = 'https://' + domain;
  config.hiddenDomain = 'recorder.' + domain;
  config.websocket = `wss://${domain}/xmpp-websocket`;

  console.log('config', config, domain, config.serviceUrl);
  JitsiMeetJS.init(config);

  return new Promise((resolve, reject) => {
    startConference(roomName)
      .then(() => {
        resolve();
      })
      .catch((err) => {
        reject(err);
      });
  });
}

export function startConference(roomName) {
  // const roomName = room; //getstate().meetn.currentRoom.toLowerCase();
  console.log("webrtc =>", jitsiConnection, roomName);
  roomName = roomName?.toLowerCase();
  return new Promise((resolve, reject) => {
    if (!jitsiConnection) {
      connect(roomName)
        .then((connection) => {
          room = connection.initJitsiConference(roomName, config);
          conference._room = room;
          resolve();
        })
        .catch((err) => {
          reject(err);
        });
    } else {
      resolve();
    }
  });
}

export async function connect(roomName) {
  JitsiMeetJS.setLogLevel(JitsiMeetJS.logLevels.ERROR);

  let serviceUrl = config.websocket || config.bosh;

  serviceUrl += `?room=${roomName}`;

  config.serviceUrl = serviceUrl;

  if (config.websocketKeepAliveUrl) {
    config.websocketKeepAliveUrl += `?room=${roomName}`;
  }

  JitsiMeetJS.init(config);
  const connection = new JitsiMeetJS.JitsiConnection(null, null, config);
  jitsiConnection = connection;
  return new Promise((resolve, reject) => {
    connection.addEventListener(
      JitsiConnectionEvents.CONNECTION_ESTABLISHED,
      handleConnectionEstablished
    );
    connection.addEventListener(
      JitsiConnectionEvents.CONNECTION_FAILED,
      handleConnectionFailed
    );

    // connection.addEventListener(
    // JitsiConnectionEvents.CONNECTION_FAILED,
    // connectionFailedHandler);
    let id = "not available";
    let password = "not available";
    const usernameOverride = jitsiLocalStorage.getItem(
      "xmpp_username_override"
    );
    const passwordOverride = jitsiLocalStorage.getItem(
      "xmpp_password_override"
    );

    if (usernameOverride && usernameOverride.length > 0) {
      id = usernameOverride; // eslint-disable-line no-param-reassign
    }
    if (passwordOverride && passwordOverride.length > 0) {
      password = passwordOverride; // eslint-disable-line no-param-reassign
    }
    console.error("chk Pass", id, password);
    connection.connect({
      id,
      password,
    });

    // function connectionFailedHandler(error, message, credentials, details) {
    // /* eslint-enable max-params */
    //     // APP.store.dispatch(
    //     //     connectionFailed(
    //     //         connection, {
    //     //             credentials,
    //     //             details,
    //     //             message,
    //     //             name: error
    //     //         }));

    //     if (isFatalJitsiConnectionError(error)) {
    //         connection.removeEventListener(
    //             JitsiConnectionEvents.CONNECTION_FAILED,
    //             connectionFailedHandler);
    //     }
    // }

    function unsubscribe() {
      connection.removeEventListener(
        JitsiConnectionEvents.CONNECTION_ESTABLISHED,
        handleConnectionEstablished
      );
      connection.removeEventListener(
        JitsiConnectionEvents.CONNECTION_FAILED,
        handleConnectionFailed
      );
    }

    function handleConnectionEstablished() {
      unsubscribe();
      console.log("CONNECTION ESTABLISHED:", connection);
      resolve(connection);
    }

    function handleConnectionFailed(err) {
      unsubscribe();
      console.error("CONNECTION FAILED:", err);
      reject(err);
    }
  });
}

export async function joinRoom() {
  // window.APP.conference._room = room;

  return new Promise((resolve) => {
    roomevents();
    resolve(room.myUserId());
  });
}

const roomevents = () => {
  const { localUser } = store.getState().conf;
  const { name } = localUser;
  room.on(JitsiConferenceEvents.TRACK_ADDED, (track) => {
    if (!track || track.isLocal()) {
      return;
    }
    dispatch(trackAdd(track));
    track.on(JitsiTrackEvents.TRACK_MUTE_CHANGED, (track) => {
      dispatch(trackMuteUpdate(track));
    });
    track.on(JitsiTrackEvents.TRACK_VIDEOTYPE_CHANGED, (type) =>
      dispatch(trackMediaTypeUpdate(track))
    );
    // changeTrackResolution();

    // video stream status update
    if (track.type === 'video') {
      track.on(JitsiTrackEvents.TRACK_STREAMING_STATUS_CHANGED, (t, status) => {
        // console.log('TRACK_STREAMING_STATUS_CHANGED', t?.ownerEndpointId, t, status, t.getTrackStreamingStatus());
        handleTrackStreamingStatusChanged(t, status);
      });
    }
  });
  room.on(JitsiConferenceEvents.TRACK_REMOVED, (track) => {
    dispatch(trackRemove(track));
  });
  room.on(JitsiConferenceEvents.CONFERENCE_JOINED, () => { });

  room.on(JitsiConferenceEvents.USER_JOINED, (_id, _user) => {
    if (_user._displayName === 'Media-Sharing') {
      console.log('USER_JOINED', _id, _user, _user._displayName);
      dispatch(setMediaShareParticipants(_id));
    }
    // dispatch(partcipantAdd(id));
  });
  room.on(JitsiConferenceEvents.USER_LEFT, (_id, _user) => {
    if (_user._displayName === 'Media-Sharing') {
      console.log('USER_LEFT', _id, _user, _user._displayName);
      dispatch(remMediaShareParticipants(_id));
    }
    // dispatch(partcipantRemove(id));
  });

  // room.on(JitsiConferenceEvents.DISPLAY_NAME_CHANGED, (userID, displayName) => {
  //   console.info(`${userID} - ${displayName}`);
  // });

  room.on(
    JitsiConferenceEvents.DOMINANT_SPEAKER_CHANGED,
    (id, previousSpeakers) => {
      const roomDetail = store.getState().conf.roomDetail;

      // console.log('DOMINANT_SPEAKER_CHANGED', id, roomDetail);
      dispatch(setDominantSpeaker(id));
      dispatch(setRecentActiveSpeaker(previousSpeakers));

      if (roomDetail?.recording && roomDetail?.recording_id) {
        const participantsJID = store.getState().conf.participantsJID;
        const mediaShareparticipantsJID = store.getState().conf.mediaShareparticipantsJID;
        const userName = mediaShareparticipantsJID === id ? 'Media-Sharing' : participantsJID[id]?.name;
       
        const payload = {
          room: roomDetail?.room,
          event_id: roomDetail?.recording_id,
          translation_data: {
            room: roomDetail?.room,
            dominant_speaker: id,
            name: userName,
            timestamp: Date.parse(new Date()),
          }
        };
        updateDominantData(payload);

      }
    }
  );

  room.on(JitsiConnectionQualityEvents.LOCAL_STATS_UPDATED, stats => {
        // console.log('LOCAL_STATS_UPDATED', stats);
    const show_fps_in_recording = store?.getState()?.conf?.roomDetail?.show_fps_in_recording ?? false;
    if (stats?.transport && stats?.transport?.length > 0 && !bridgeLogged) {
      let remoteIp = getIP(stats?.transport[0].ip);
      if (remoteIp) {
        bridgeLogged = true;
        let payload = {
          bridge: remoteIp,
        };
        logSentryCustomEvent('BRIDGE ASSIGNED', 'info', payload);
      }
    }

    if (show_fps_in_recording && stats?.framerate){
      dispatch(setAttendeesFrameRate(stats?.framerate));
    }
  });

  room.setReceiverVideoConstraint("720");
  room.join();

  room.setDisplayName(name);
};

export const changeTrackResolution = (participantId) => {
  let receiverConstraints = {
    constraints: {},
    defaultConstraints: { maxHeight: 0 },
    lastN: -1,
    onStageSources: [],
    selectedSources: [],
  };

  const height = participantId?.length <= 2 ? '2160' : participantId?.length <= 4 ? '720' : '180';

  participantId.forEach((p) => {
    receiverConstraints.constraints[p] = { maxHeight: height };
  });
  receiverConstraints.onStageSources = participantId;
  receiverConstraints.selectedSources = participantId;
  // console.log('receiverConstraints1', receiverConstraints);
  try {
    room.setReceiverConstraints(receiverConstraints);
  } catch (error) {
    console.error(
      error,
      `Failed to set receiver video constraints ${JSON.stringify(
        receiverConstraints,
      )}`,
    );
  }
};

export const changeTrackResolutionActive = (participantId) => {
  const galleryUserIds = getPartcipiantsUserIds();

  const removedDuplicateIds = galleryUserIds.filter(filterItem => !participantId.includes(filterItem));
  const receiverVideoIds = [...participantId, ...removedDuplicateIds];
  let receiverConstraints = {
    constraints: {},
    defaultConstraints: { maxHeight: 180 },
    lastN: -1,
    onStageSources: [],
    selectedSources: [],
  };
  receiverVideoIds.forEach((p, index) => {
    if (index <= 1) {
      receiverConstraints.constraints[p] = { maxHeight: '2160' };
    } else {
      receiverConstraints.constraints[p] = { maxHeight: '180' };
    }
  });
  receiverConstraints.onStageSources = [participantId[0]];
  // console.log('receiverConstraints2', receiverConstraints);

  try {
    room.setReceiverConstraints(receiverConstraints);
  } catch (error) {
    console.error(
      error,
      `Failed to set receiver video constraints ${JSON.stringify(
        receiverConstraints,
      )}`,
    );
  }
};
export const changeTrackResolutionSmallActive = (participantId) => {
  const galleryUserIds = getPartcipiantsUserIds();

  const removedDuplicateIds = galleryUserIds.filter(filterItem => !participantId.includes(filterItem));
  const receiverVideoIds = [...participantId, ...removedDuplicateIds];
  let receiverConstraints = {
    constraints: {},
    defaultConstraints: { maxHeight: 180 },
    lastN: -1,
    onStageSources: [],
    selectedSources: [],
  };

  receiverVideoIds.forEach((p, index) => {
    if (index <= 1) {
      receiverConstraints.constraints[p] = { maxHeight: '2160' };
    } else {
      receiverConstraints.constraints[p] = { maxHeight: '180' };
    }
  });
  receiverConstraints.onStageSources = [participantId[0]];
  // console.log('receiverConstraints3', receiverConstraints);
  try {
    room.setReceiverConstraints(receiverConstraints);
  } catch (error) {
    console.error(
      error,
      `Failed to set receiver video constraints ${JSON.stringify(
        receiverConstraints,
      )}`,
    );
  }
};
export const changeTrackResolutionPresentation = async (participantId) => {
  if (participantId.length > 0) {
    const galleryUserIds = getPartcipiantsUserIds();
    const removedDuplicateIds = galleryUserIds.filter(
      filterItem => !participantId.includes(filterItem),
    );
    const receiverVideoIds = [...participantId, ...removedDuplicateIds];
    const receiverConstraints = {
      constraints: {},
      defaultConstraints: { maxHeight: 0 },
      lastN: config.channelLastN,
      onStageSources: [],
      selectedSources: [],
    };

    receiverVideoIds.forEach((p, index) => {
      if (index === 0) {
        receiverConstraints.constraints[p] = { maxHeight: '2160' };
      } else {
        receiverConstraints.constraints[p] = { maxHeight: '180' };
      }
    });
    receiverConstraints.onStageSources = [participantId[0]];

    // console.info('receiverConstraints4', JSON.stringify(receiverConstraints));
    try {
      room.setReceiverConstraints(receiverConstraints);
    } catch (error) {
      console.error(
        error,
        `Failed to set receiver video constraints ${JSON.stringify(
          receiverConstraints,
        )}`,
      );
    }
  }
};

export const changeTrackResolutionAudienceMode = async (
  participantId,
  recentSpeakersCount = 0,
) => {
  if (participantId.length === 0) {
    return;
  }
  const { audioMode } = store?.getState()?.conf;

  const receiverVideoIds = audioMode ? [] : [...participantId];

  const receiverConstraints = {
    constraints: {},
    defaultConstraints: { maxHeight: 0 },
    lastN: participantId.length,
    onStageSources: [],
    selectedSources: [],
  };

  receiverVideoIds.forEach((p, index) => {
    // Apply high quality (2160p) to recent speakers, 180p to regular participants
    if (index < recentSpeakersCount) {
      receiverConstraints.constraints[p] = { maxHeight: '2160' };
    } else {
      receiverConstraints.constraints[p] = { maxHeight: '180' };
    }
  });
  receiverConstraints.selectedSources = audioMode ? [] : [...participantId];

  console.log('receiverConstraints', receiverConstraints);

  try {
    room.setReceiverConstraints(receiverConstraints);
  } catch (error) {
    console.error(
      error,
      `Failed to set receiver video constraints ${JSON.stringify(
        receiverConstraints,
      )}`,
    );
  }
};

export function _requestingSubtitlesChange({ enabled, language = 'en', token_unique }) {
  console.log('_requestingSubtitlesChange 1', token_unique);

  if (enabled) {
    if (token_unique && language) {
      lemUserLanguages[token_unique] = COUNTRY_CODES[language][0];
    }
  } else {
    if (lemUserLanguages[token_unique]) {
      delete lemUserLanguages[token_unique];
    }
  }


  if (!transcriptionEnabled) {
    transcriptionEnabled = true;
    room?.setLocalParticipantProperty(P_NAME_REQUESTING_TRANSCRIPTION, true);
  }

  if (
    enabled &&
    room?.getTranscriptionStatus() ===
    JitsiMeetJS.constants.transcriptionStatus.OFF
  ) {
    room?.dial(TRANSCRIBER_DIAL_NUMBER).catch(e => {
      console.error('Error dialing', e);
    });
  }

  const userLanguages = [...new Set(Object.values(lemUserLanguages))] ?? [COUNTRY_CODES[language][0]];

  console.log("userLanguages", language, lemUserLanguages, userLanguages)
  if (userLanguages) {
    room?.setLocalParticipantProperty(P_NAME_TRANSLATION_LANGUAGE, userLanguages);
  }

  if (enabled && !captionListnerEnabled) {
    captionListnerEnabled = true
    room?.on(
      JitsiConferenceEvents.ENDPOINT_MESSAGE_RECEIVED,
      receiverEndpointMessageListener,
    );
  } else {
    // room?.off(
    //   JitsiConferenceEvents.ENDPOINT_MESSAGE_RECEIVED,
    //   receiverEndpointMessageListener,
    // );
  }
}

export function _disableSubtitles() {
  console.log('_disableSubtitles');

  transcriptionEnabled = false;
  room?.setLocalParticipantProperty(P_NAME_REQUESTING_TRANSCRIPTION, false);

  if (captionListnerEnabled) {
    captionListnerEnabled = false;
    room?.off(
      JitsiConferenceEvents.ENDPOINT_MESSAGE_RECEIVED,
      receiverEndpointMessageListener,
    );
  }
}

function receiverEndpointMessageListener(participant, data) {
  const roomDetail = store?.getState()?.conf?.roomDetail;
  //  console.log('ENDPOINT_MESSAGE_RECEIVED', participant?._displayName, data,);
  let newTranscriptMessage = {
    room: roomDetail?.room,
    participant: { id: data?.participant?.id, name: data?.participant?.name },
    message_id: data?.message_id,
    text: data?.text,
    stability: data?.stability,
    transcript: data?.transcript,
    language: data?.language,
    type: data?.type,
    timestamp: data?.timestamp,
    receivedAt: Date.now(),
  };

   // console.log('newTranscriptMessage', newTranscriptMessage);
  sendCaptionMsg(newTranscriptMessage);
  
//  captionBuffer.push(newTranscriptMessage);
//  pruneOld(Date.now());
}
// function pruneOld(now) {
//   while (captionBuffer.length && now - captionBuffer[0].receivedAt > LAST_30_SECONDS) {
//     captionBuffer.shift();
//   }
// }

export function setLocalParticipantLanguage({ language = 'en', token_unique }) {

  if (token_unique && language) {
    lemUserLanguages[token_unique] = COUNTRY_CODES[language][0];
  }
  if (language) {
    const userLanguages = [...new Set(Object.values(lemUserLanguages))] ?? COUNTRY_CODES[language][0];

    console.log("userLanguages", language, lemUserLanguages, userLanguages)
    room?.setLocalParticipantProperty(P_NAME_TRANSLATION_LANGUAGE, userLanguages);

  }
}